import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getActions = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/actions`);
    return response.data;
  } catch (error) {
    console.error('Error fetching actions:', error.response?.data || error);
    throw error;
  }
};

export const getActionById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/actions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching action:', error.response?.data || error);
    throw error;
  }
};

export const createAction = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/actions`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating action:', error.response?.data || error);
    throw error;
  }
};

export const updateAction = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/actions/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating action:', error.response?.data || error);
    throw error;
  }
};

export const deleteAction = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/actions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting action:', error.response?.data || error);
    throw error;
  }
};
